define('AA.OutOfStock.Shopping', [
    'Cart.Detailed.View',
    'LiveOrder.Model',
    'jQuery',
    'underscore'
], function(CartDetailedView, LiveOrderModel, jQuery, _) {
    'use strict';

    var _OOSUtils = null;
    var _container = null;
    var _pendingCheck = false;
    var _currentOOSLines = [];
    var _isRemoving = false;

    var originalShowContent = CartDetailedView.prototype.showContent;

    CartDetailedView.prototype.showContent = function() {
        var result = originalShowContent.apply(this, arguments);

        if (_isRemoving) return result;

        if (_OOSUtils) {
            setTimeout(function() {
                if (!_isRemoving) runCartOOSCheck();
            }, 500);
        } else {
            _pendingCheck = true;
        }

        return result;
    };

    function runCartOOSCheck() {
        if (!_OOSUtils || _isRemoving) return;

        var cartModel = LiveOrderModel.getInstance();

        _OOSUtils.checkAvailability(cartModel, function(oosLines) {
            if (_isRemoving) return;

            _OOSUtils.clearBanner();
            _OOSUtils.clearOOSMarks();

            if (oosLines.length) {
                _currentOOSLines = oosLines;
                showCartOOS(oosLines, cartModel);
            } else {
                _currentOOSLines = [];
                enableCheckoutButton();
            }
        });
    }

    function showCartOOS(oosLines, cartModel) {
        var placeholder = jQuery('[data-type="cart-detail-oos-error-placeholder"]');

        if (!placeholder.length) {
            placeholder = jQuery('<div data-type="cart-detail-oos-error-placeholder" class="cart-detail-oos-error-placeholder"></div>');
            jQuery('.cart-detailed').prepend(placeholder);
        }

        var message = 'Some items in your bag are currently out of stock. Please remove them before proceeding to checkout.';

        _OOSUtils.renderBanner(placeholder, message, false);
        placeholder.show();

        var countText = oosLines.length === 1
            ? '1 Item Out of Stock'
            : oosLines.length + ' Items Out of Stock';

        jQuery('.oos-count-label').remove();
        var countHtml = '<div class="oos-count-label">' +
            '<span class="oos-count-text">' + countText + '</span>' +
            ' &mdash; <a href="#" class="oos-remove-link" data-action="remove-oos-items-cart">Remove Out of Stock Items</a>' +
            '</div>';

        jQuery('.cart-detailed-body').prepend(countHtml);

        _OOSUtils.markOOSLines(oosLines);
        _OOSUtils.addOOSLabels(oosLines);

        disableCheckoutButton();
    }

    function disableCheckoutButton() {
        jQuery('#btn-proceed-checkout')
            .attr('disabled', 'disabled')
            .addClass('disabled')
            .css({ opacity: '0.5', 'pointer-events': 'none' });
    }

    function enableCheckoutButton() {
        jQuery('#btn-proceed-checkout')
            .removeAttr('disabled')
            .removeClass('disabled')
            .css({ opacity: '', 'pointer-events': '' });
    }

    function handleRemoveOOSItems() {
        if (!_currentOOSLines.length) return;

        var cart = _container.getComponent('Cart');
        _isRemoving = true;

        _OOSUtils.removeOOSLines(cart, _currentOOSLines, function() {
            _currentOOSLines = [];
            _OOSUtils.clearBanner();
            _OOSUtils.clearOOSMarks();
            _isRemoving = false;
        });
    }

    return {
        init: function init(container, OOSUtils) {
            _OOSUtils = OOSUtils;
            _container = container;

            jQuery(document).on('click.oosCartHandler', '[data-action="remove-oos-items-cart"]', function(e) {
                e.preventDefault();
                handleRemoveOOSItems();
            });

            if (_pendingCheck) {
                _pendingCheck = false;
                setTimeout(function() {
                    runCartOOSCheck();
                }, 500);
            }
        }
    };
});
